// extracted by mini-css-extract-plugin
export default {"tools":"UserView_tools__pNEXU","total":"UserView_total__k-fKd"};